
import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import { Box, Input, Link, Switch, Table, Typography } from '@mui/joy'
import { post, Token } from '../../../Script/Session';
import Headline from '../../../components/headline/Headline';
import SearchIcon from '@mui/icons-material/Search';
import debounce from 'lodash/debounce';
function PointsKontoOverview() {
    const [data, setdata] = useState();
    const [shownichtmitglieder, setshownichtmitglieder] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = debounce(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 300);
        handler();
        return () => handler.cancel();
    }, [searchTerm]);
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        let response = post(body, "/userlist");
        setdata(JSON.parse(response));
    }, []);
    return (
        <>

            <Typography sx={{ mt: 2, mb: 2 }} component="label" level="body-lg" endDecorator={<Switch checked={shownichtmitglieder} onChange={(e) => setshownichtmitglieder(e.target.checked)} sx={{ ml: 1 }} />}>
                Nicht Mitglieder Anzeigen
            </Typography>
            <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", mb: 2 }}>
                <Input
                    placeholder="Suche..."
                    startDecorator={<SearchIcon />}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ width: 500 }}
                />
            </Box>
            <Typography level="body-sm" sx={{ mb: 2 }} color='danger'>Bitte auf den Namen drücken um zum Profil zu gelangen</Typography>
            <Table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Puntke vor 3 Jahren</th>
                        <th>Punkte vor 2 Jahren</th>
                        <th>Punkte Vorjahr</th>
                        <th>Punkte</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        !shownichtmitglieder && data && data.result.slice().filter((a) => a.mitglied).filter(item => item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td><Link href={window.location.origin + "/my-profile/" + item.id}>{item.name}</Link></td>
                                    <td>{item.email}</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>{item.punkte} Punkt/e</td>
                                    <td><Link href={window.location.origin + "/punktekonto_details/" + item.id}>Details</Link></td>
                                </tr>
                            )

                        })
                    }
                    {
                        shownichtmitglieder && data && data.result.slice().filter(item => item.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())).map((item) => {
                            return (
                                <tr key={item.id}>
                                    <td><Link href={window.location.origin + "/my-profile/" + item.id}>{item.name}</Link></td>
                                    <td>{item.email}</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>{item.punkte} Punkt/e</td>
                                    <td><Link href={window.location.origin + "/punktekonto_details/" + item.id}>Details</Link></td>
                                </tr>
                            )

                        })
                    }

                </tbody>
            </Table>

        </>
    )
}

export default PointsKontoOverview
